import { Code } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { FunctionNodeData } from '@repo/shared-types';

export const FunctionNode = ({
  data,
  selected,
}: {
  data: FunctionNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="function"
    icon={<Code size={16} />}
    label={data.label}
    subtitle={data.outputKey ? `→ ${data.outputKey}` : undefined}
    selected={selected}
  />
);
